import { useState } from 'react';
import PropTypes from 'prop-types';
import { PageHeader } from 'client/js/util/layout_utils';
import FileBrowser from './file_browser';

const Filemanager = ({ baseApiUrl }) => {
  const [viewMode, setViewMode] = useState('single'); // 'single' or 'split'
  const [sharedClipboard, setSharedClipboard] = useState(null); // Shared clipboard state

  const viewButtons = (
    <div className="btn-group">
      <button
        className={`btn ${viewMode === 'single' ? 'btn-primary' : 'btn-light'}`}
        onClick={() => setViewMode('single')}
      >
        <i className="fa fa-window-maximize mr-2" />
        Einzelansicht
      </button>
      <button
        className={`btn ${viewMode === 'split' ? 'btn-primary' : 'btn-light'}`}
        onClick={() => setViewMode('split')}
      >
        <i className="fa fa-columns mr-2" />
        Split-View
      </button>
    </div>
  );

  return (
    <>
      <PageHeader text="Dateimanager" buttons={viewButtons} />

      <div className={`filemanager-container ${viewMode}`}>
        {viewMode === 'single' ? (
          <FileBrowser
            paneId="main"
            sharedClipboard={sharedClipboard}
            setSharedClipboard={setSharedClipboard}
            baseApiUrl={baseApiUrl}
          />
        ) : (
          <div
            className="split-panes"
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '20px'
            }}
          >
            <FileBrowser
              paneId="left"
              className="pane-left"
              sharedClipboard={sharedClipboard}
              setSharedClipboard={setSharedClipboard}
              baseApiUrl={baseApiUrl}
            />
            <FileBrowser
              paneId="right"
              className="pane-right"
              sharedClipboard={sharedClipboard}
              setSharedClipboard={setSharedClipboard}
              baseApiUrl={baseApiUrl}
            />
          </div>
        )}
      </div>
    </>
  );
};

Filemanager.propTypes = {
  baseApiUrl: PropTypes.string,
};

export default Filemanager;